/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Ramp, useTopModelExistByName } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useModalZIndex } from './context/zIndex';
import { ModalIcon } from './icon';
import { ModalWrapper } from './wrapper';
import { ModalScrollContainer } from './scrollContainer';

const style: ouiStyle.InStyle = {
  position: 'relative',
  lines: 'full',
  widthLines: 'full',
  paddingHorizontal: 'simple',
  paddingBottom: 'simple',
  boxShadow: '0 0 10px 3px rgba(0, 0, 0, 0.1)',
};

type ModalContainerProps = {
  fullScreenUpMd?: boolean,
  textAlign?: ouiStyle.InStyle['textAlign'],
  goBackOnClick?: React.MouseEventHandler<HTMLButtonElement>,
  hasBack?: boolean,
  children: React.ReactNode,
}

export const ModalContainer = React.forwardRef<HTMLDivElement, ModalContainerProps>((props, ref) => {
  const {
    fullScreenUpMd,
    textAlign,
    goBackOnClick,
    hasBack,
    children,
  } = props;
  const zIndex = useModalZIndex();
  const hasIcon = useTopModelExistByName('ModalIconContent');
  const css = React.useMemo(() => ouiStyle.mediaQuery(ouiStyle.makeCss({
    ...style,
    paddingTop: hasIcon ? 5 : 4,
    zIndex,
  })), [zIndex, hasIcon]);
  return (
    <ModalWrapper
      ref={ref}
      fullScreenUpMd={fullScreenUpMd}
    >
      <div
        css={css}
      >
        <Ramp rampName="ModalCloseButton" />
        {hasBack ? (
          <Ramp
            rampName="ModalBackButton"
            onClick={goBackOnClick}
          />
        ) : null}
        {hasIcon ? <ModalIcon /> : null}
        <ModalScrollContainer
          textAlign={textAlign}
        >
          <Ramp
            rampName="ModalContent"
          />
          {children}
        </ModalScrollContainer>
      </div>
    </ModalWrapper>
  );
});
